// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__t_1bU","item":"styles_item__8UV8B"};